import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../components/common/Button';

function PendingApproval() {
  const location = useLocation();
  const { userInfo } = location.state || {};

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen flex items-start justify-center bg-hooray-beige-40 pt-16 px-4">
      <div className="max-w-2xl w-full p-6 bg-white rounded-lg shadow-md">
        <div className="text-center">
          <svg 
            className="w-16 h-16 mx-auto text-yellow-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          
          <h1 className="text-3xl font-bold mt-4 mb-2 text-amber-600 font-mont">Account Pending Approval</h1>
          
          <div className="mt-6 mb-8 text-hooray-dark-text">
            <p className="mb-4">
              Thank you for registering! Your account has been created successfully, but is currently pending administrator approval.
            </p>
            <p className="mb-4">
              Once your account is approved, you will be able to sign in and access all features of the system.
            </p>
            <p>
              If you have any questions or need assistance, please contact our support team.
            </p>
          </div>

          {userInfo && (
            <div className="mt-8 mb-8 p-4 bg-gray-50 rounded-md text-left">
              <h2 className="text-lg font-semibold mb-3 text-gray-700 font-mont">Registration Details</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-600">Name</p>
                  <p className="text-hooray-dark-text">{userInfo.fullName || `${userInfo.firstName} ${userInfo.lastName}`}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Email</p>
                  <p className="text-hooray-dark-text">{userInfo.email}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Mobile Number</p>
                  <p className="text-hooray-dark-text">{userInfo.cellphone}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Site</p>
                  <p className="text-hooray-dark-text">{userInfo.siteName || "Pending verification"}</p>
                </div>
              </div>
            </div>
          )}

          <div className="mt-8">
            <Button
              to="/"
              variant="cta"
            >
              Go back Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PendingApproval; 